import { gql } from '@apollo/client'

export const BYDESIGN_PRODUCT_QUERY = gql`
  query GetBydesignProduct($productId: ID!, $sponsorId: ID!) {
    getProductItem(productId: $productId, sponsorId: $sponsorId) {
      message
      success
      product {
        isAutoShipItem
        isEnrollment
        wholesalePrice
        doNotAllowAddToCartFlagged
        allowJSCartPurchase
        level
        sortOrder
        searchField
        groupItemOverrideStock
        allowBackOrder
        doNotAllowAddToCartCountry
        doNotAllowAddToCartStock
        images
        categoryID
        isFeaturedItem
        largeImageURL
        smallImageURL
        compare
        currencySymbol
        currencyTypeID
        price
        longDetail
        displayName
        productID
        inventoryID
      }
    }
  }
`
